import createAsyncActionType from "../../../utilities/createAsyncActionType";

export const GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT = createAsyncActionType(
  "GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT"
);

export const GET_SCORING_RESULTS_REPORT_ENTRIES = createAsyncActionType(
  "GET_SCORING_RESULTS_REPORT_ENTRIES"
);

export const GET_SCORING_RESULTS_REPORT_SCORING_TYPES = createAsyncActionType(
  "GET_SCORING_RESULTS_REPORT_SCORING_TYPES"
);

export const EXPORT_SCORING_RESULTS_REPORT_CSV = createAsyncActionType(
  "EXPORT_SCORING_RESULTS_REPORT_CSV"
);

export const SET_SCORING_RESULTS_REPORT_ENTRIES_CURRENT_PAGE =
  "SET_SCORING_RESULTS_REPORT_ENTRIES_CURRENT_PAGE";

export const SET_SCORING_RESULTS_REPORT_ENTRIES_FILTERS =
  "SET_SCORING_RESULTS_REPORT_ENTRIES_FILTERS";

export const CLEAR_EXPORT_SCORING_RESULTS_REPORT_CSV =
  "CLEAR_EXPORT_SCORING_RESULTS_REPORT_CSV";

export const CLEAR_SCORING_RESULTS_REPORT = "CLEAR_SCORING_RESULTS_REPORT";

export const SET_SCORING_RESULTS_ITEMS_PER_PAGE =
  "SET_SCORING_RESULTS_ITEMS_PER_PAGE";

export const SET_SCORING_RESULTS_NO_ENTRIES_MESSAGE =
  "SET_SCORING_RESULTS_NO_ENTRIES_MESSAGE";



// WEBPACK FOOTER //
// ./src/features/reports/types/scoringResultsReportTypes.js